import { useMutation } from "@tanstack/react-query";
import { getPublicAuthHeader, getReturnWidgetFetchClient } from "./return-widget-client";

async function getPresignedUrl(file: File): Promise<{ url: string; s3Key: string }> {
  const { data, response } = await getReturnWidgetFetchClient().POST(
    "/public/return-request/image/presigned-url",
    {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      body: { fileName: file.name, contentType: file.type } as any,
      params: { header: getPublicAuthHeader() },
    },
  );
  if (!response.ok) throw new Error("Failed to get presigned URL");
  return data as { url: string; s3Key: string };
}

async function uploadToS3(presignedUrl: string, file: File): Promise<void> {
  const response = await fetch(presignedUrl, {
    method: "PUT",
    body: file,
    headers: { "Content-Type": file.type },
  });
  if (!response.ok) throw new Error("S3 upload failed");
}

async function confirmUpload(s3Key: string): Promise<string> {
  const { data, response } = await getReturnWidgetFetchClient().POST(
    "/public/return-request/image/confirm",
    {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      body: { key: s3Key } as any,
      params: { header: getPublicAuthHeader() },
    },
  );
  if (!response.ok) throw new Error("Failed to confirm upload");
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return (data as any).url as string;
}

export async function publicUploadReturnImage(file: File): Promise<string> {
  const { url: presignedUrl, s3Key } = await getPresignedUrl(file);
  await uploadToS3(presignedUrl, file);
  return confirmUpload(s3Key);
}

export function usePublicUploadReturnImage() {
  return useMutation({ mutationFn: publicUploadReturnImage });
}
